export enum FromDateOption {
  Today = "Today",
  FromBeginning = "From Beginning (default)",
  CustomDate = "Custom Date",
}

export enum DataSourceSortOption {
  DateAdded = "DateAdded",
  NameAscending = "NameAscending",
  NameDescending = "NameDescending",
  MostTransactions = "MostTransactions",
  HighestValue = "HighestValue",
}

export const DataSourceSortOptionName: Record<DataSourceSortOption, string> = {
  DateAdded: "Date Added",
  HighestValue: "Highest Value",
  MostTransactions: "Most Transactions",
  NameAscending: "Name A-Z",
  NameDescending: "Name Z-A",
};
